import { lazy, Suspense } from "react";
import { RouterProvider } from "react-router-dom";
import { observer } from "mobx-react-lite";

import router from "./routes/router";
import IntlWrapper from "./components/translations";
import {appStore, AppStoreContext} from "./store/app-store.ts";
import DebugPanel from "./components/debug-panel.tsx";

declare const __SIM_ENABLED__: boolean;

const SimPanel = __SIM_ENABLED__
    ? lazy(() => import("./components/sim-panel/sim-panel.tsx"))
    : null;

const App = observer(function App() {
  return (
    <AppStoreContext.Provider value={appStore}>
      <IntlWrapper>
        <RouterProvider router={router} />
        <DebugPanel />
        {SimPanel && (
          <Suspense fallback={null}>
            <SimPanel />
          </Suspense>
        )}
      </IntlWrapper>
    </AppStoreContext.Provider>
  );
});

export default App;
